export const legacyTypes = {
  LIST_LEGACY: 'LIST_LEGACY_ITEM',
  LIST_LEGACY_SUCCESS: 'LIST_LEGACY_ITEM_SUCCESS',
  LIST_LEGACY_FAIL: 'LIST_LEGACY_ITEM_FAIL',

  CREATE_LEGACY: 'CREATE_LEGACY_ITEM',
  CREATE_LEGACY_SUCCESS: 'CREATE_LEGACY_ITEM_SUCCESS',
  CREATE_LEGACY_FAIL: 'CREATE_LEGACY_ITEM_FAIL'
};
